import InfiniteReviewsList from './infinite-reviews-list';

export default InfiniteReviewsList;
